'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useSuspenseQuery } from '@repo/tanstack/query';
import { Field, FieldError, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps } from 'react';
import { ReadOnlyTooltip, useReadOnly } from '../../components/readonly.tsx';
import { useFieldContext } from '../../lib/form-context.ts';
export const FormPodRequirementSelect = t0 => {
  const $ = _c(39);
  const {
    "data-testid": dataTestId,
    isPending: t1,
    onChange,
    onFocus,
    placeholder: t2,
    variant: t3
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const variant = t3 === undefined ? "default" : t3;
  const field = useFieldContext();
  const api = useApi();
  let t4;
  if ($[0] !== api.companies.requirements.pod.list) {
    t4 = api.companies.requirements.pod.list.queryOptions();
    $[0] = api.companies.requirements.pod.list;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    data: podRequirements
  } = useSuspenseQuery(t4);
  const isReadOnly = useReadOnly();
  if (isReadOnly) {
    let t5;
    if ($[2] !== field || $[3] !== podRequirements) {
      t5 = podRequirements.find(requirement => requirement.id.toString() === field.state.value)?.title ?? "-";
      $[2] = field;
      $[3] = podRequirements;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== t5) {
      t6 = <ReadOnlyTooltip>{t5}</ReadOnlyTooltip>;
      $[5] = t5;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    return t6;
  }
  let t5;
  if ($[7] !== podRequirements) {
    t5 = podRequirements.map(_temp);
    $[7] = podRequirements;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== field || $[10] !== onChange) {
    t6 = val => {
      if (val) {
        field.handleChange(val);
      }
      onChange?.();
    };
    $[9] = field;
    $[10] = onChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = field.state.value;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex w-full justify-between gap-2 p-0 text-base data-[size=default]:h-6");
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = dataTestId ?? "form-pod-requirement-select-trigger";
  let t10;
  if ($[13] !== placeholder) {
    t10 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="form-pod-requirement-select.tsx" />;
    $[13] = placeholder;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== isPending) {
    t11 = isPending && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[15] = isPending;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== onFocus || $[18] !== t10 || $[19] !== t11 || $[20] !== t9 || $[21] !== variant) {
    t12 = <SelectTrigger className={t8} data-testid={t9} hideChevron={true} onFocus={onFocus} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="form-pod-requirement-select.tsx">{t10}{t11}</SelectTrigger>;
    $[17] = onFocus;
    $[18] = t10;
    $[19] = t11;
    $[20] = t9;
    $[21] = variant;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== podRequirements) {
    t13 = podRequirements.map(_temp2);
    $[23] = podRequirements;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13) {
    t14 = <SelectContent className="min-w-52" data-sentry-element="SelectContent" data-sentry-source-file="form-pod-requirement-select.tsx">{t13}</SelectContent>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== field.state.value || $[28] !== isPending || $[29] !== t12 || $[30] !== t14 || $[31] !== t5 || $[32] !== t6) {
    t15 = <div className="relative"><Select disabled={isPending} items={t5} onValueChange={t6} value={t7} data-sentry-element="Select" data-sentry-source-file="form-pod-requirement-select.tsx">{t12}{t14}</Select></div>;
    $[27] = field.state.value;
    $[28] = isPending;
    $[29] = t12;
    $[30] = t14;
    $[31] = t5;
    $[32] = t6;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== field.state.meta.errors) {
    t16 = <FieldError errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-pod-requirement-select.tsx" />;
    $[34] = field.state.meta.errors;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormPodRequirementSelect" data-sentry-source-file="form-pod-requirement-select.tsx">{t15}{t16}</Field>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};
function _temp(requirement_0) {
  return {
    label: requirement_0.title,
    value: requirement_0.id.toString()
  };
}
function _temp2(requirement_1) {
  return <SelectItem data-testid={`form-pod-requirement-select-option-${requirement_1.alias}`} key={requirement_1.id} value={requirement_1.id.toString()}>{requirement_1.title}</SelectItem>;
}